export const HINT_SHOW = {
  tooltip: 'Показать описание',
  icon: 'mdi-book-open-blank-variant',

}

export const HINT_HIDE = {
  tooltip: 'Скрыть описание',
  icon: 'mdi-book-open-variant',
}
